var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSTouch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "1827.391 6183.664 36.101 36.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 16.379,
    x2: 16.379,
    y1: 29.81,
    y2: 34.265,
    gradientTransform: "scale(.98166 1.01869)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.949,
    x2: 0.056,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b72b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b1104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 7.316,
    x2: 0.432,
    y1: 3.855,
    y2: 3.855,
    gradientTransform: "scale(1.23959 .80672)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 7.316,
    x2: 0.432,
    y1: 3.855,
    y2: 3.855,
    gradientTransform: "scale(1.23959 .80672)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 7.316,
    x2: 0.432,
    y1: 3.855,
    y2: 3.855,
    gradientTransform: "scale(1.23959 .80672)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: 7.316,
    x2: 0.432,
    y1: 3.855,
    y2: 3.855,
    gradientTransform: "scale(1.23959 .80672)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M3.944 33.37c-1.069 0-1.972-.6-1.972-1.365v-4.4H1a1 1 0 0 1-1-1V7.371a1 1 0 0 1 1-1h.972V1.365C1.972.6 2.875 0 3.944 0h10.769v1.365h6.371V0h11.073c1.069 0 1.972.6 1.972 1.365v5.006h.971a1 1 0 0 1 1 1v19.236a1 1 0 0 1-1 1h-.972V32c0 .761-.9 1.365-1.972 1.365z",
    className: "cls-1",
    "data-name": "Union 3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 38.157,
    height: 39.371,
    x: 1826.363,
    y: 6180.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Touch sensor"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    "data-name": "Mask Group 3",
    transform: "translate(1827.391 6185.029)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M.758 6.371h34.584a.758.758 0 0 1 .758.758v19.719a.758.758 0 0 1-.758.758H.758A.758.758 0 0 1 0 26.848V7.129a.758.758 0 0 1 .758-.758Z",
    className: "cls-1",
    "data-name": "Path 27"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    transform: "translate(-1827.39 -6183.66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1.972 0h10.77v1.365h6.371V0h11.072c1.069 0 1.972.6 1.972 1.365v30.64c0 .761-.9 1.365-1.972 1.365H1.972C.9 33.371 0 32.766 0 32.005V1.365C0 .6.9 0 1.972 0Z",
    "data-name": "Path 1",
    transform: "translate(1829.36 6183.66)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.584 9.404h.758v6.067h-.758z",
    "data-name": "Rectangle 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.91 9.404h.758v6.067H.91z",
    "data-name": "Rectangle 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.584 18.05h.758v6.067h-.758z",
    "data-name": "Rectangle 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.91 18.05h.758v6.067H.91z",
    "data-name": "Rectangle 4"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M0 0h9.556v6.219H0z",
    className: "cls-4",
    "data-name": "Rectangle 6",
    transform: "translate(1831.942 6199.742)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M0 0h9.556v6.219H0z",
    className: "cls-4",
    "data-name": "Rectangle 9",
    transform: "rotate(90 -2170.324 4018.876)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M0 0h9.556v6.219H0z",
    className: "cls-4",
    "data-name": "Rectangle 7",
    transform: "rotate(180 929.471 3102.98)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M0 0h9.556v6.219H0z",
    className: "cls-4",
    "data-name": "Rectangle 8",
    transform: "rotate(-90 4029.266 2186.934)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b72b1c",
    stroke: "#8b1104",
    strokeWidth: 0.25,
    "data-name": "Ellipse 1",
    transform: "translate(1839.375 6196.708)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.067,
    cy: 6.067,
    r: 6.067,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.067,
    cy: 6.067,
    r: 5.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1843.911 6200.354s-.048.917-.69.925c-.642.008-1.312 0-1.312 0a2.123 2.123 0 0 0-.409 1.52c0 1.138.321 1.442.321 1.442h1.463a.58.58 0 0 1 .628.628v1.5a3.487 3.487 0 0 0 1.586.258 5.8 5.8 0 0 0 1.507-.258v-1.5a.655.655 0 0 1 .66-.628 9.594 9.594 0 0 0 1.3-.126s.356-.336.39-1.467c.034-1.131-.317-1.477-.317-1.477h-1.522a.576.576 0 0 1-.685-.609 10.168 10.168 0 0 1 0-1.476 4.326 4.326 0 0 0-2.917 0c-.019.627 0 1.268 0 1.268z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSTouch);
export default __webpack_public_path__ + "static/media/sTouch.cc0ed63f1df4c0521734a900abc2c770.svg";
export { ForwardRef as ReactComponent };